import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ProjectProposalForm.css';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { getCsiCodes } from 'components/admin/projects/details/project-proposal/store/selectors';
import {
  toggleItemDelete,
  newSubItem,
} from 'components/admin/projects/details/project-proposal/store/actions';
import Input from 'components/shared/input/Input';
import Dropdown from 'components/shared/dropdown/Dropdown';
import numeral from 'numeral';
import Number from 'components/shared/text/Number';
import SearchableDropDownPaginated from 'components/shared/dropdown/SearchableDropDownPaginated';
import settingsPng from 'images/settings.png';
import OutsideAlerter from 'components/shared/OutsideAlerter';
import ProjectProposalSubItem from 'components/admin/projects/details/project-proposal/ProjectProposalSubItem';

class ProjectProposalItem extends Component {
  static propTypes = {
    itemKey: PropTypes.string.isRequired,
    item: PropTypes.shape({}).isRequired,
    itemDelete: PropTypes.bool,
    costsShown: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showAwardRecommendation: PropTypes.bool.isRequired,
    onCsiCodeOptions: PropTypes.func.isRequired,
    onTotalItemCost: PropTypes.func.isRequired,
    onLoadSubcontractors: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubItemChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    itemDelete: false,
  };

  handleItemChange = (key, attribute, value) => {
    this.props.onChange(key, attribute, value);
  };

  handleCsiCodeChange = (key, csiCode, csiCodeId) => {
    const csiCodeOptions = this.csiCodeOptions(csiCode);
    const newCsiCode = csiCodeOptions.find(
      (option) => option.value === csiCodeId
    );
    if (newCsiCode) {
      this.handleItemChange(key, 'csiCodeId', csiCodeId);
    } else {
      alert('Division already taken');
    }
  };

  handleAwardRecommendationChange = (key, id, name) => {
    this.handleItemChange(key, 'awardRecommendationId', id);
    this.handleItemChange(key, 'awardRecommendationName', name);
  };

  handleItemDeleteOptionClick = (key) => {
    this.props.dispatch(toggleItemDelete(key));
  };

  handleItemDelete = (key) => {
    const confirmed = window.confirm('Are you sure?');
    confirmed && this.handleItemChange(key, 'delete', true);
  };

  handleAddSubcategory = (key, item, csiCode) => {
    this.props.dispatch(newSubItem(key, item, csiCode));
    this.handleItemDeleteOptionClick(key);
  };

  selectedCsiCode = () => {
    const { item, csiCodes } = this.props;
    return csiCodes.find((csiCode) => csiCode.id === item.csiCodeId);
  };

  csiCodeOptions = (csiCode) => {
    const { onCsiCodeOptions } = this.props;
    const csiCodes = onCsiCodeOptions();
    csiCode && csiCodes.push({ value: csiCode.id, label: csiCode.division });
    return csiCodes;
  };

  renderSettings = (csiCode) => {
    const { item, itemDelete } = this.props;
    const key = this.props.itemKey;
    return (
      <div className="proposal-item-settings">
        <div
          className="settings-icon"
          onClick={() => this.handleItemDeleteOptionClick(key)}
        >
          <img src={settingsPng} alt="settings" />
        </div>
        {itemDelete && (
          <OutsideAlerter
            onClickOutside={() => this.handleItemDeleteOptionClick(key)}
          >
            <div
              className={`settings-menu ${csiCode ? 'settings-menu-2' : ''}`}
            >
              {csiCode && (
                <div
                  className="settings-menu-item"
                  onClick={() => this.handleAddSubcategory(key, item, csiCode)}
                >
                  Add Subcategory
                </div>
              )}
              <div
                className="settings-menu-item"
                onClick={() => this.handleItemDelete(key)}
              >
                Delete
              </div>
            </div>
          </OutsideAlerter>
        )}
      </div>
    );
  };

  activeSubItemsKeys = () => {
    const { item } = this.props;
    return Object.keys(item.subItems || {}).filter(
      (subItemKey) => !item.subItems[subItemKey].delete
    );
  };

  render() {
    const {
      item,
      currentProject,
      costsShown,
      onTotalItemCost,
      onLoadSubcontractors,
      onSubItemChange,
    } = this.props;
    const key = this.props.itemKey;
    const csiCode = this.selectedCsiCode();
    const csiCodeOptions = this.csiCodeOptions(csiCode);
    const activeSubItemsKeys = this.activeSubItemsKeys();
    const hasSubItems = activeSubItemsKeys.length > 0;
    const lastSubItemKey = activeSubItemsKeys[activeSubItemsKeys.length - 1];
    const totalItemCost = onTotalItemCost(item);
    return (
      <React.Fragment>
        {hasSubItems && (
          <tr>
            <td>{!this.props.readOnly && this.renderSettings(csiCode)}</td>
            <td>{csiCode.division}</td>
            <td>{csiCode.label}</td>
            <td>
              {costsShown && <Number value={totalItemCost} format="$ 0,0" />}
            </td>
            <td>
              {costsShown && (
                <Number
                  value={totalItemCost / currentProject.sq_footage}
                  format="$ 0,0.[00]"
                />
              )}
            </td>
            <td />
          </tr>
        )}
        <tr className={hasSubItems ? 'project-proposal-sub-item' : ''}>
          <td>
            {!this.props.readOnly &&
              !hasSubItems &&
              this.renderSettings(csiCode)}
          </td>
          <td>
            {this.props.readOnly || !item.newItem ? (
              csiCode.division
            ) : (
              <Dropdown
                options={csiCodeOptions}
                placeholder="00"
                value={item.csiCodeId}
                onChange={(newOption) =>
                  this.handleCsiCodeChange(key, csiCode, newOption.value)
                }
              />
            )}
          </td>
          <td>
            {csiCode &&
              `${csiCode.label}${
                costsShown && hasSubItems ? ' - Original Cost' : ''
              }`}
          </td>
          <td>
            {costsShown &&
              (this.props.readOnly ? (
                <Number value={item.tradeCosts || ''} format="$ 0,0" />
              ) : (
                <Input
                  placeholder="$0"
                  value={
                    item.tradeCosts
                      ? numeral(item.tradeCosts).format('$ 0,0')
                      : ''
                  }
                  onChange={(value) =>
                    this.handleItemChange(
                      key,
                      'tradeCosts',
                      numeral(value).value()
                    )
                  }
                />
              ))}
          </td>
          <td>
            {costsShown && (
              <Number
                value={
                  (item.tradeCosts &&
                    item.tradeCosts / currentProject.sq_footage) ||
                  ''
                }
                format="$ 0,0.[00]"
              />
            )}
          </td>
          <td>
            {this.props.readOnly ? (
              item.awardRecommendationName
            ) : item.awardRecommendationName ? (
              <div
                className="award-recommendation-selected"
                onClick={() => {
                  this.handleAwardRecommendationChange(key, null, null);
                }}
              >
                <span className="remove">X</span>
                <span>{item.awardRecommendationName}</span>
              </div>
            ) : this.props.showAwardRecommendation ? (
              <div className="award-recommendation-wrapper">
                <div className="award-recommendation">
                  <div className="add-row-plus">+</div>
                  <SearchableDropDownPaginated
                    loadOptions={(input, page) =>
                      onLoadSubcontractors(input, csiCode && csiCode.id, page)
                    }
                    value={item.awardRecommendationId}
                    onChange={(input) =>
                      this.handleAwardRecommendationChange(
                        key,
                        input.value,
                        input.label
                      )
                    }
                    placeholder="Select Subcontractor"
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </td>
        </tr>
        {activeSubItemsKeys.map((subItemKey) => {
          const subItem = item.subItems[subItemKey];
          return (
            <ProjectProposalSubItem
              key={subItem.division}
              itemKey={key}
              subItemKey={subItemKey}
              subItem={subItem}
              csiCode={csiCode}
              isLastSubItem={subItemKey === lastSubItemKey}
              costsShown={costsShown}
              readOnly={this.props.readOnly}
              showAwardRecommendation={this.props.showAwardRecommendation}
              onLoadSubcontractors={onLoadSubcontractors}
              onChange={onSubItemChange}
            />
          );
        })}
      </React.Fragment>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    csiCodes: getCsiCodes(state),
  };
})(ProjectProposalItem);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-proposal/ProjectProposalItem.js